import UnitList from "../unit/UnitList";
import StationList from "../station/StationList";
import CapabilityList from "../capability/CapabilityList";
import OrganisationEdit from "./OrganisationEdit";
import UserList from "../user/UserList";
import UnitMissionCapabilityList from "../capability/UnitMissionCapabilityList";
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import UserGroupList from "../usergroup/UserGroupList";


type OrganisationMainArgs = {
    selectedStationId: string;
    selectedStationIdChanged: (selectedStationId: string) => void;
};

const OrganisationMain = ({ selectedStationId, selectedStationIdChanged }: OrganisationMainArgs) => {
    const { t } = useTranslation();
    const [tabIndexState, setTabIndexState] = useState(0);



    useEffect(() => {
        const savedTabIndex = localStorage.getItem('selectedTabIndex');
        if (savedTabIndex !== null) {
            setTabIndexState(Number(savedTabIndex));
        }
    }, []);

    const onTabSelect = (index: number) => {
        setTabIndexState(index);
        localStorage.setItem('selectedTabIndex', index.toString());
    }

    return (
        <>
            <Tabs selectedIndex={tabIndexState} onSelect={(index) => onTabSelect(index)}>
                <TabList>
                    <Tab>{t('organisation.organisation')}</Tab>
                    <Tab>{t('organisation.users')}</Tab>
                    <Tab>{t('organisation.stations')}</Tab>
                    <Tab>{t('organisation.units')}</Tab>
                    <Tab>{t('organisation.userGroups')}</Tab>
                    <Tab>{t('organisation.capabilities')}</Tab>
                    <Tab>{t('organisation.unitMissionCapabilities')}</Tab>
                </TabList>
                <TabPanel>
                    <OrganisationEdit />
                </TabPanel>
                <TabPanel>
                    <UserList selectedStationId={selectedStationId} selectedStationIdChanged={(id) => selectedStationIdChanged(id)} />
                </TabPanel>
                <TabPanel>
                    <StationList />
                </TabPanel>
                <TabPanel>
                    <UnitList selectedStationId={selectedStationId} selectedStationIdChanged={(id) => selectedStationIdChanged(id)} />
                </TabPanel>
                <TabPanel>
                    <UserGroupList />
                </TabPanel>
                <TabPanel>
                    <CapabilityList />
                </TabPanel>
                <TabPanel>
                    <UnitMissionCapabilityList selectedStationId={selectedStationId} selectedStationIdChanged={(id) => selectedStationIdChanged(id)} />
                </TabPanel>
            </Tabs>
        </>
    );
};

export default OrganisationMain;